import BoldSmallText from '@/components/BoldSmallText';
import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import { dashboardDocs } from '@/constants/docs';
import { BoldTextDiv, CustomIcon, FullHeightDiv, PointerDiv } from '@/pages/Dashboard/styled';
import { Badge, BlockStack, Box, Button, Card, Collapsible, Divider, Icon, InlineStack } from '@shopify/polaris';
import { ArrowRightIcon, XIcon } from '@shopify/polaris-icons';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const InformationCard = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation('dashboard');
  const [dismissed, setDismissed] = useState(isOpen);

  const informationData = useMemo(
    () => [
      {
        title: t('inforCard.inforSetup.0'),
        guideLink: dashboardDocs.setupDeliveryDateInCheckoutPage,
      },
      {
        title: t('inforCard.inforSetup.1'),
        guideLink: dashboardDocs.addDateTimeInOrderConfirmationEmail,
      },
      {
        title: t('inforCard.inforSetup.2'),
        guideLink: dashboardDocs.addDateTimeInThankYouPageAndOrderStatusPage,
      },
    ],
    [t],
  );

  return (
    <FullHeightDiv>
      <Collapsible id={'cta-widget-banner'} open={dismissed}>
        <Card padding={'0'}>
          <Box padding={'0'} position="relative">
            <Box position="absolute" insetBlockStart="0" insetInlineEnd="0" padding={'300'}>
              <Button
                icon={XIcon}
                variant="tertiary"
                onClick={() => {
                  onClose();
                  setDismissed(false);
                }}
              />
            </Box>
            <Box padding={'0'}>
              <BlockStack gap="300">
                <div className="not-fullHeight-box">
                  <Box padding={'300'}>
                    <BlockStack gap={'150'}>
                      <InlineStack gap={'200'}>
                        <BoldText>{t('inforCard.title')}</BoldText>
                        <BoldTextDiv>
                          <Badge tone="success">{t('inforCard.badge')}</Badge>
                        </BoldTextDiv>
                      </InlineStack>
                      <RegularText tone="subdued">Almost there! Perfect your delivery now!</RegularText>
                    </BlockStack>
                  </Box>
                  <Divider borderColor="border" />
                </div>
                <Box paddingInline={'300'} paddingBlockEnd={'300'}>
                  <BlockStack gap={'300'}>
                    {informationData.map((item) => (
                      <Box key={item.title} padding={'150'} background="bg-surface-tertiary-hover" borderRadius="200">
                        <BlockStack gap={'200'} align="center">
                          <BoldSmallText>{item.title}</BoldSmallText>
                          <div className="not-full-inline">
                            <InlineStack blockAlign="center">
                              <PointerDiv onClick={() => window.open(item.guideLink)}>
                                <RegularText tone="subdued">{t('inforCard.guide')}</RegularText>
                              </PointerDiv>
                              <PointerDiv onClick={() => window.open(item.guideLink)}>
                                <Box paddingInlineStart={'100'}>
                                  <CustomIcon>
                                    <Icon source={ArrowRightIcon} />
                                  </CustomIcon>
                                </Box>
                              </PointerDiv>
                            </InlineStack>
                          </div>
                        </BlockStack>
                      </Box>
                    ))}
                  </BlockStack>
                </Box>
              </BlockStack>
            </Box>
          </Box>
        </Card>
      </Collapsible>
    </FullHeightDiv>
  );
};
